@keyframes bounce-icon {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}


.live-status-label {
  align-items: center;
  display: flex;
  font: use-font("500 11px/1");
  gap: 4px;
  padding: 2px 5px;

  &[data-active="false"] {
    border: 1px solid var(--palette-foreground-secondary);
    color: var(--palette-foreground-secondary);
  }

  &[data-active="true"] {
    border: 1px solid var(--palette-accent-urgent);
    color: var(--palette-accent-urgent);

    &::before {
      animation: bounce-icon 500ms ease infinite alternate;
      background-color: var(--palette-accent-urgent);
      border-radius: 50%;
      content: "";
      display: block;
      height: 6px;
      width: 6px;
    }
  }
}
